import * as mns from '../mutation-types';

export default {
    state () {
        return {
            login: "",
            password: "",
        }
    },
    getters: {
        login(state){
            return state.login;
        },
        password(state){
            return state.password;
        }
    },
    mutations: {
        [mns.SET_LOGIN](state, login){
            state.login = login;
        },
        [mns.SET_PASSWORD](state, password){
            state.password = password;
        }
    }
} // export.